module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step4-pict02-full-9329ae0e3c4b1a74581d5532ce44bb4d.jpg";